import { useQuery } from "@tanstack/react-query";
import { Card, Col, Radio, Row } from "antd";
import { getVehicleDataAvailability } from "apis/vehicleAnalyticsApis";
import APIError from "components/Common/APIError";
import CalendarHeatmapChart from "components/Common/Charts/CalendarHeatmapChart";
import Loading from "components/Common/Loading";
import NoData from "components/Common/NoData";
import { getTimeUnitShortForm } from "components/Common/Utils";
import { useState } from "react";

const list = [
  { label: "IMU", value: "imu" },
  { label: "Telemetry", value: "telemetry" },
  { label: "Motor", value: "motor" },
  { label: "Battery", value: "battery" },
  { label: "Location", value: "location" },
];

const DataAvailability = ({
  selectedDateRange,
  datePickerType,
  vehicleDetails,
}) => {
  const [activeKey, setActiveKey] = useState("imu");

  const { data: dataAvailabilityDetails, 
    isLoading: vehicleDataApiLoading,
    isError: vehicleDataApiIsError,
    error: vehicleDataApiError } = useQuery({
    queryKey: [
      "dataAvailability",
      vehicleDetails?.vehId,
      selectedDateRange,
      datePickerType,
      activeKey,
    ],
    queryFn: () =>
      getVehicleDataAvailability(
        vehicleDetails?.vehId,
        selectedDateRange,
        datePickerType,
        activeKey
      ),
    keepPreviousData: true,
    enabled: !!(vehicleDetails?.vehId && selectedDateRange),
    staleTime: 1 * 10 * 60 * 1000,
  });

  const onChangeHandler = (key) => {
    setActiveKey(key);
  };

  return (
    <>
      <Row gutter={[16, 16]} className="routes">
        <Col xs={24} sm={24} md={24} lg={6} xl={6} className="mt1">
          <Card className="vaCards">
            <Radio.Group
              onChange={(e) => onChangeHandler(e.target.value)}
              className="routes-tab-filter mb1"
              value={activeKey}
              options={list}
            />
          </Card>

          <Card className="mt1 vaCards" title={"Subscription Details"}>
            <div style={{ minHeight: "90px" }}>
              <p>
                <span className="grey">Plan:</span>{" "}
                {vehicleDetails?.subscription?.comboPlanName}
              </p>
              <p>
                <span className="grey">Data Frequency:</span>{" "}
                {vehicleDetails?.subscription?.value}
                {getTimeUnitShortForm(vehicleDetails?.subscription?.unit)}
              </p>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={18} xl={18} id="geo" className="mt1">
          <Card className="vaCards" title="Data Availability">
            {vehicleDataApiLoading ?
              <Loading />
            : vehicleDataApiIsError ?
              <APIError message={vehicleDataApiError?.message} />
            : dataAvailabilityDetails?.timePercentageBreakups ? (
              <CalendarHeatmapChart
                data={dataAvailabilityDetails?.timePercentageBreakups}
                vehicleDataApiLoading />
            ) : <NoData />}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DataAvailability;
